<template>
  <div :class="['base-card bg-white shadow-md rounded-xl border border-gray-100 p-6', $attrs.class]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',
}
</script>

<style scoped>
.base-card {
  transition: box-shadow 0.2s;
}
.base-card:hover {
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
}
</style>
